export const AUTH_SCOPES = {
    RUM: 'RUM',
    INGEST: 'INGEST',
    API: 'API',
};
